// removed by extract-text-webpack-plugin
module.exports = {"backtoprev-text":"index__backtoprev-text___IVajR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/BackToPrev/index.less
// module id = 1247
// module chunks = 3